import { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import Profile from "./Profile";
import Timetable from "./Timetable";
import Marks from "./Marks";
import Notice from "../../components/Notice";
import Material from "./Material";
import { useLocation, useNavigate } from "react-router-dom";
import ViewAttendance from "./ViewAttendance";
import Certifications from "./Certifications";
import Fees from "./Fees";
import EditStudent from "./EditStudent";
import OnlineCompiler from "./OnlineCompiler";
import Transport from "./Transport";
import StudentPlacementProfile from "./PlacementProfile";
import AIAssistant from "./AIAssistant";
import LibraryRAGAssistant from "./LibraryRAGAssistant";
import DSASheet from "./DSASheet";
import StudentHostelPortal from "./Hostel/HostelPortal";
import { Toaster } from "react-hot-toast";
import { FiTrendingUp, FiCheckCircle, FiBookOpen, FiCalendar, FiCode } from "react-icons/fi";
import NoticeTicker from "../../components/NoticeTicker";

const Home = () => {
  const [selectedMenu, setSelectedMenu] = useState("My Profile");
  const router = useLocation();
  const navigate = useNavigate();
  const [load, setLoad] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  useEffect(() => {
    const activeToken = localStorage.getItem("token");
    if (router.state === null && !activeToken) {
      navigate("/");
    }
    setLoad(true);

    // Listen for navbar profile click
    const handleOpenProfile = () => setSelectedMenu("My Profile");
    window.addEventListener("openProfile", handleOpenProfile);
    return () => window.removeEventListener("openProfile", handleOpenProfile);
  }, [navigate, router.state]);

  const renderContent = () => {
    switch (selectedMenu) {
      case "My Profile":
        return <Profile />;
      case "DSA Sheet":
        return <DSASheet userType="Student" />;
      case "Library RAG Assistant":
        return <LibraryRAGAssistant />;
      case "Timetable":
        return <Timetable />;
      case "Marks":
        return <Marks />;
      case "Material":
        return <Material />;
      case "Notice":
        return <Notice />;
      case "ViewAttendance":
        return <ViewAttendance />;
      case "Certifications":
        return <Certifications />;
      case "Fees":
        return <Fees />;
      case "Transport":
        return <Transport />;
      case "Edit Student":
        return <EditStudent />;
      case "OnlineCompiler":
        return <OnlineCompiler />;
      case "Placement":
        return <StudentPlacementProfile />;
      case "Hostel":
        return <StudentHostelPortal />;
      case "AI Assistant":
        return <AIAssistant />;
      default:
        return <Profile />;
    }
  };

  return (
    <>
      <Toaster position="bottom-right" reverseOrder={false} />
      {load && (
        <div className="min-h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100 transition-colors duration-250">
          <Navbar />
          <Sidebar
            selectedMenu={selectedMenu}
            setSelectedMenu={setSelectedMenu}
            userType="Student"
            isCollapsed={isSidebarCollapsed}
            setIsCollapsed={setIsSidebarCollapsed}
          />

          {/* Main Content Area */}
          <div className={`transition-all duration-300 ${isSidebarCollapsed ? "md:ml-16 w-full md:w-[calc(100%-4rem)]" : "md:ml-64 w-full md:w-[calc(100%-16rem)]"} ml-0 min-h-[calc(100vh-4rem)]`}>
            <div className="p-4 md:p-6 lg:p-8 w-full space-y-6">
              {/* Dashboard Banner & Quick Access Cards */}
              {selectedMenu === "My Profile" && (
                <div className="space-y-6">
                  {/* 🌟 Header Banner */}
                  <div className="rounded-2xl bg-white dark:bg-slate-900 p-6 border border-slate-200 dark:border-slate-800 shadow-xs dark:shadow-xl flex items-center justify-between">
                    <div>
                      <h1 className="text-xl md:text-2xl font-bold tracking-tight text-slate-900 dark:text-white">Student Dashboard</h1>
                      <p className="text-xs md:text-sm text-slate-500 dark:text-slate-400 font-medium mt-1">Welcome to Sphoorthy Engineering College Academic Portal</p>
                    </div>
                    <div className="hidden sm:flex items-center space-x-2 px-3 py-1.5 rounded-full bg-indigo-50 dark:bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 border border-indigo-100 dark:border-indigo-500/20 text-xs font-bold">
                      <FiTrendingUp className="w-4 h-4" />
                      <span>Academic Session 2026</span>
                    </div>
                  </div>

                  {/* Quick Access Bento Section */}
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <button
                      onClick={() => setSelectedMenu("DSA Sheet")}
                      className="p-5 rounded-2xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 hover:border-amber-500/50 hover:bg-slate-50 dark:hover:bg-slate-850 transition-all text-left group shadow-xs dark:shadow-lg cursor-pointer"
                    >
                      <div className="w-10 h-10 rounded-xl bg-amber-50 dark:bg-amber-500/10 border border-amber-200 dark:border-amber-500/20 text-amber-600 dark:text-amber-400 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                        <FiCode className="w-5 h-5" />
                      </div>
                      <h3 className="font-extrabold text-slate-900 dark:text-white text-base group-hover:text-amber-600 dark:group-hover:text-amber-300 transition-colors">DSA & LeetCode Sheet</h3>
                      <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">500+ Topic-wise coding questions & video tutorials</p>
                    </button>

                    <button
                      onClick={() => setSelectedMenu("ViewAttendance")}
                      className="p-5 rounded-2xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 hover:border-emerald-500/50 hover:bg-slate-50 dark:hover:bg-slate-850 transition-all text-left group shadow-xs dark:shadow-lg cursor-pointer"
                    >
                      <div className="w-10 h-10 rounded-xl bg-emerald-50 dark:bg-emerald-500/10 border border-emerald-200 dark:border-emerald-500/20 text-emerald-600 dark:text-emerald-400 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                        <FiCheckCircle className="w-5 h-5" />
                      </div>
                      <h3 className="font-extrabold text-slate-900 dark:text-white text-base group-hover:text-emerald-600 dark:group-hover:text-emerald-300 transition-colors">Attendance Progress</h3>
                      <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">Track monthly percentage & subject attendance</p>
                    </button>

                    <button
                      onClick={() => setSelectedMenu("Timetable")}
                      className="p-5 rounded-2xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 hover:border-indigo-500/50 hover:bg-slate-50 dark:hover:bg-slate-850 transition-all text-left group shadow-xs dark:shadow-lg cursor-pointer"
                    >
                      <div className="w-10 h-10 rounded-xl bg-indigo-50 dark:bg-indigo-500/10 border border-indigo-200 dark:border-indigo-500/20 text-indigo-600 dark:text-indigo-400 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                        <FiCalendar className="w-5 h-5" />
                      </div>
                      <h3 className="font-extrabold text-slate-900 dark:text-white text-base group-hover:text-indigo-600 dark:group-hover:text-indigo-300 transition-colors">Class Timetable</h3>
                      <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">Daily schedule, lab hours & period details</p>
                    </button>

                    <button
                      onClick={() => setSelectedMenu("Material")}
                      className="p-5 rounded-2xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 hover:border-cyan-500/50 hover:bg-slate-50 dark:hover:bg-slate-850 transition-all text-left group shadow-xs dark:shadow-lg cursor-pointer"
                    >
                      <div className="w-10 h-10 rounded-xl bg-cyan-50 dark:bg-cyan-500/10 border border-cyan-200 dark:border-cyan-500/20 text-cyan-600 dark:text-cyan-400 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                        <FiBookOpen className="w-5 h-5" />
                      </div>
                      <h3 className="font-extrabold text-slate-900 dark:text-white text-base group-hover:text-cyan-600 dark:group-hover:text-cyan-300 transition-colors">Study Material</h3>
                      <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">Download subject notes & lecture slides</p>
                    </button>
                  </div>
                </div>
              )}

              {/* Render Active Component */}
              {renderContent()}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
